export class ProgressStatus {
    constructor() {    
    }
    status: ProgressStatusEnum = ProgressStatusEnum.START;
    percentage?: number;
}
    
export enum ProgressStatusEnum {
    START, COMPLETE, IN_PROGRESS, ERROR
}